"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var client_1 = require("react-dom/client");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_2 = require("redux-persist/integration/react");
var app_1 = require("./app");
var store_1 = require("./store");
var root = (0, client_1.createRoot)(document.getElementById("app"));
if (!root)
    throw new Error("Root element #app not found");
root.render((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }, children: (0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: store_1.store, children: (0, jsx_runtime_1.jsx)(react_2.PersistGate, { loading: null, persistor: store_1.persistor, children: (0, jsx_runtime_1.jsx)(app_1.App, {}) }) }) }) }));
